import type { SEOPropsType } from '..';

export const SEO_CUSTOM_FORMULA_ANTI_AGING_CONTENT: SEOPropsType = {
  title: 'Custom Formula: RX Anti-Aging Treatment Cream | Curology',
  description:
    'Improve your skincare routine with Curology’s RX anti-aging Custom Formula. Get a personalized anti-aging formula tailored to your needs.',
};
